import { render, staticRenderFns } from "./RearJacketEdit.vue?vue&type=template&id=8d5a2752&scoped=true&"
import script from "./RearJacketEdit.vue?vue&type=script&lang=js&"
export * from "./RearJacketEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5a2752",
  null
  
)

export default component.exports